import {Component} from "react";
import {Button, ButtonGroup, Form, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import appLib from "../../../libs/appLib.mjs";
import CloseIcon from "../../../media/images/CloseIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import CheckIcon from "../../../media/images/CheckIcon.mjs";
import AppFlagTrueIcon from "../../../media/app-images/AppFlagTrueIcon.mjs";
import AppFlagFalseIcon from "../../../media/app-images/AppFlagFalseIcon.mjs";

const prefix="SimulationFlowSettings1Modal";

const AxleRow = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: parseFloat(props.value),
		}
		this.changed = this.changed.bind(this);
	}
	changed(value) {
		if ( this.state.timeout ) try { clearTimeout(this.timeout) } catch (e) { }
		if ( value > this.props.max ) value = this.props.max;
		this.setState({
			value: value,
			timeout: setTimeout( ()=>{
				this.props.onChange(this.props.axle,parseFloat(this.state.value));
			},500)
		});
	}
	render() {
		return (
			<InputGroup
				style={ this.props.axle === "o" ? { pointerEvents: "none", opacity: ".5"} : undefined }
			>
				<InputGroupText
					style={{ width: "40px", textAlign:"center" }}
					onClick={ ()=>{ this.changed(0) }}
				>
					<Label
						style={{
							fontWeight: "bold",
							color: this.state.value >=1 ? "#090" : "#c00"
						}}
					>
						{ this.props.axle.toUpperCase() }
					</Label>
				</InputGroupText>
				<InputGroupText className={"flex-grow-1"}>
					<Input
						type="range"
						min={0}
						max={1}
						step={.01}
						value={this.state.value}
						onChange={ e => this.changed(e.target.value) }
					/>
				</InputGroupText>
				<InputGroupText
					style={{ width: "80px", justifyContent:"flex-end", userSelect: "none" }}
					onClick={ ()=>{ this.changed(1) }}
				>
					{ String(Math.round(this.state.value * 100))+"%" }
				</InputGroupText>
			</InputGroup>
		)
	}
}

const SimulationFlowSettings1Modal = class extends Component {
	constructor(props) {
		super(props);
		const s = {};
		Object.entries( props.bene.status ).forEach(([k,v]) =>{
			s[k] = parseFloat(v);
		});
		this.state = {
			status: s,
			healthy: (s.c+s.i+s.a+s.o) >= 4,
			updated: Date.now(),
		}
		this.axleChange = this.axleChange.bind(this);
	}
	axleChange( axle, value ) {
		const s = this.state.status;
		s[axle] = value;
		s.o = Math.min( s.c, s.i, s.a );
		this.setState({ status: s, updated: Date.now(), healthy: (s.c+s.i+s.a+s.o) >= 4 });
	}
	render() {
		return (
			<Modal
				className={prefix}
				isOpen={true}
				toggle={this.props.close}
				fade={false}
				onOpened={appLib.modalAutoFocus}
			>
				<ModalHeader toggle={this.props.close}>
					{ this.props.bene.label }
				</ModalHeader>
				<ModalBody>
					<div
						style={{margin:"-1rem 0 0 0"}}
					>
						<div
							key={ 'icon' + this.state.updated }
							style={{width:"calc(2 * var(--icon-size))",margin:"0 auto"}}
						>
							{ this.state.healthy ? <AppFlagTrueIcon /> : <AppFlagFalseIcon /> }
						</div>
					</div>
					<Form onSubmit={ e => e.preventDefault() }>
						{ 'ciao'.split('').map( axle => (
							<AxleRow
								key={ axle + this.state.updated }
								axle={axle}
								value={ this.state.status[ axle ] }
								max={ 1 }
								onChange={ this.axleChange }
							/>
						))}
					</Form>
				</ModalBody>
				<ModalFooter>
					<ButtonGroup
						className={"btn-icon"}
					>
						<Button
							onClick={this.props.close}
							color="warning"
						>
							<i>
								<CloseIcon />
							</i>
							<b>
								<TextLabel value={"Cancel"} />
							</b>
						</Button>
						{ (! this.props.bene?.new) && (
							<Button
								color={"danger"}
								onClick={()=> { this.props.remove(this.props.bene) }}
							>
								<b>
									<TextLabel value={"Delete"} />
								</b>
								<i>
									<AppFlagTrueIcon />
								</i>
							</Button>
						)}
					</ButtonGroup>
					<Button
						className={"btn-icon"}
						disabled={ !! this.state.healthy }
						onClick={()=>{
							const d = this.props.bene;
							d.status = this.state.status;
							this.props.save(d);
						}}
						color={"success"}
					>
						<b>
							<TextLabel value={"OK"} />
						</b>
						<i>
							<CheckIcon />
						</i>
					</Button>
				</ModalFooter>
			</Modal>
		)
	}
}

export default SimulationFlowSettings1Modal;